
export class MapLoadAction {
  static readonly type = '[Map] load';
}

export class MapLoadMarkersAction {
  static readonly type = '[Map] load markers';
}

export class MapSetOptionsAction {
  static readonly type = '[Map] update center';

  constructor(public center: any, public zoom: number) {
  }
}

export class MapFilterBooksyAction {
  static readonly type = '[Map] filter booksy';

  constructor(public booksy: boolean) {
  }
}

export class MapFilterSteamPodAction {
  static readonly type = '[Map] filter steam_pod';

  constructor(public steamPod: boolean) {
  }
}
